var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1107 13C55.811 13 58 15.1968 58 17.9067V28.2154C57.9999 30.9252 55.8109 33.1221 53.1107 33.1221H45.2401C45.2246 35.8186 43.0424 37.9999 40.3518 38H14.8893C12.1891 38 10.0001 35.8032 10 33.0933V22.7846C10 20.0747 12.189 17.8779 14.8893 17.8779H40.3518C40.6157 17.8779 40.8746 17.8988 41.1272 17.9392L41.533 16.5382C42.1396 14.442 44.0534 13.0001 46.2285 13H53.1107Z",
    fill: "url(#paint0_linear_540_12647)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 48,
    height: 12,
    fill: "#94ABC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 27C6 24.7909 7.79086 23 10 23H37.8367H47.3878H54C56.2091 23 58 24.7909 58 27V34.5909V53C58 55.2091 56.2091 57 54 57H10C7.79086 57 6 55.2091 6 53V27Z",
    fill: "#E9F3FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32.7708C6 30.0094 8.23858 27.7708 11 27.7708H37.2L49.68 27H53C55.7614 27 58 29.2386 58 32V58C58 61.3137 55.3137 64 52 64H11C8.23858 64 6 61.7614 6 59V32.7708Z",
    fill: "#AAC1DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30C6 27.7909 7.79086 26 10 26H36H45H55V37.9318V57C55 59.2091 53.2091 61 51 61H10C7.79086 61 6 59.2091 6 57V30Z",
    fill: "url(#paint1_linear_540_12647)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2344 2H39.0338C41.2243 2 43 3.77573 43 5.9662C43 8.15667 41.2243 9.93239 39.0338 9.93239L28.0676 9.9324C21.4029 9.9324 16 15.3352 16 22",
    stroke: "#2E69EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 10.5631,
    height: 5.59223,
    rx: 2.79612,
    fill: "url(#paint2_linear_540_12647)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 36,
    r: 4,
    fill: "#407FF6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 46,
    r: 4,
    fill: "#407FF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 36,
    r: 4,
    fill: "#407FF6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 46,
    r: 4,
    fill: "#407FF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 36,
    r: 4,
    fill: "#407FF6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 46,
    r: 4,
    fill: "#407FF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_540_12647",
    x1: 10,
    y1: 18.7927,
    x2: 48.2791,
    y2: 20.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_540_12647",
    x1: -0.5,
    y1: 20.5,
    x2: 19.705,
    y2: 75.3317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_540_12647",
    x1: 9,
    y1: 29.932,
    x2: 20.4951,
    y2: 33.6602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5094FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3470F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.645e9c8de87e518abad6dd7666e56b71.svg";
export { ForwardRef as ReactComponent };